import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminNavigationComponent } from './components/admin-navigation/admin-navigation.component';
import { AdminSidenavComponent } from './components/admin-sidenav/admin-sidenav.component';
import { AdminUserOrderHistoryComponent } from './components/admin-user-order-history/admin-user-order-history.component';
import { AdminUserPreviewComponent } from './components/admin-user-preview/admin-user-preview.component';
import { AdminUserScoresListComponent } from './components/admin-user-scores-list/admin-user-scores-list.component';
import { AdminUserDiscountListComponent } from './components/admin-user-discount-list/admin-user-discount-list.component';
import { AdminUserSharedFilesListComponent } from './components/admin-user-shared-files-list/admin-user-shared-files-list.component';
import { AdminDocumentPreviewComponent } from './components/dialogs/admin-document-preview/admin-document-preview.component';
import { AdminOrderErrorReportComponent } from './components/dialogs/admin-order-error-report/admin-order-error-report.component';
import { AdminOrderPreviewComponent } from './components/dialogs/admin-order-preview/admin-order-preview.component';
import { AnnouncePiceThesisEditComponent } from './components/dialogs/admin-order-preview/announce-pice-thesis-edit/announce-pice-thesis-edit.component';
import { AdminUnconfirmSharedFileComponent } from './components/dialogs/admin-unconfirm-shared-file/admin-unconfirm-shared-file.component';
import { AdminDashboardComponent } from './components/menu/admin-dashboard/admin-dashboard.component';
import { AdminOrdersComponent } from './components/menu/admin-orders/admin-orders.component';
import { AdminPaymentsComponent } from './components/menu/admin-payments/admin-payments.component';
import { AdminSetPostTrackingPaymentComponent } from './components/menu/admin-payments/payment-control/admin-set-post-tracking-payment/admin-set-post-tracking-payment.component';
import { NextPhaseDialogComponent } from './components/menu/admin-payments/payment-control/next-phase-dialog/next-phase-dialog.component';
import { PaymentControlComponent } from './components/menu/admin-payments/payment-control/payment-control.component';
import { AdminSharedFilesComponent } from './components/menu/admin-shared-files/admin-shared-files.component';
import { AdminUsersComponent } from './components/menu/admin-users/admin-users.component';
import { CellarComponent } from './components/menu/cellar/cellar.component';
import { AdminTransactionsComponent } from './components/admin-transactions/admin-transactions.component';
import { AdminCellarAddComponent } from './components/menu/cellar/admin-cellar-add/admin-cellar-add.component';
import { TalcColorComponent } from 'src/app/shared/components/order/talc-color-selector/talc-color/talc-color.component';
import { DeliveryMethodsComponent } from './components/delivery-methods/delivery-methods.component';
import { AddDeliveryMethodComponent } from './components/delivery-methods/add-delivery-method/add-delivery-method.component';
import { DeleteMethodConfirmComponent } from './components/delivery-methods/delete-method-confirm/delete-method-confirm.component';
import { AdminTasksComponent } from './components/menu/admin-tasks/admin-tasks.component';
import { AddTaskComponent } from './components/menu/admin-tasks/add-task/add-task.component';
import { DeleteTaskComponent } from './components/menu/admin-tasks/delete-task/delete-task.component';
import { EditUserScoreComponent } from './components/admin-user-scores-list/edit-user-score/edit-user-score.component';
import { EditUserDiscountComponent } from './components/admin-user-discount-list/edit-user-discount/edit-user-discount.component';

@NgModule({
  declarations: [
    AdminComponent,
    AdminDashboardComponent,
    AdminNavigationComponent,
    AdminSidenavComponent,
    AdminSharedFilesComponent,
    AdminDocumentPreviewComponent,
    AdminUnconfirmSharedFileComponent,
    AdminUsersComponent,
    AdminUserPreviewComponent,
    AdminUserOrderHistoryComponent,
    AdminUserSharedFilesListComponent,
    AdminUserScoresListComponent,
    AdminUserDiscountListComponent,
    AdminOrdersComponent,
    AdminOrderPreviewComponent,
    AdminOrderErrorReportComponent,
    AdminPaymentsComponent,
    PaymentControlComponent,
    NextPhaseDialogComponent,
    AdminSetPostTrackingPaymentComponent,
    AnnouncePiceThesisEditComponent,
    CellarComponent,
    AdminTransactionsComponent,
    AdminCellarAddComponent,
    DeliveryMethodsComponent,
    AddDeliveryMethodComponent,
    DeleteMethodConfirmComponent,
    AdminTasksComponent,
    AddTaskComponent,
    DeleteTaskComponent,
    EditUserScoreComponent,
    EditUserDiscountComponent,
  ],
  imports: [CommonModule, AdminRoutingModule, SharedModule],
  providers: [],
})
export class AdminModule {}
